import React from 'react';
import { translate } from 'react-i18next';
import { Text, View, Image, StyleSheet, Platform, ActivityIndicator } from 'react-native';
import PropTypes from 'prop-types';
import HelpSvg from '../../assets/icons/help.svg';

import { Button, ButtonTypes } from '../../components';
import { FormError } from '../../ui';
import { moderateScale } from 'react-native-size-matters';
import Theme from '../../theme';
import Sizes from '../../sizes';
import BookingFlowFooter from './BookingFlowFooter';
import { defaultScale } from '../../utils';

const ConfirmAction = ({
  title,
  subtitle,
  rightButtonText,
  leftButtonText,
  rightButtonPress,
  leftButtonPress,
  metaText,
  isLoading,
  error,
  leftButtonOverrideStyles,
  rightButtonOverrideStyles,
}) => (
    <View style={styles.container}>
      <View style={styles.confirmationCenterContainer}>
        <HelpSvg width={defaultScale(80)} height={defaultScale(80)} color={Theme.PRIMARY}/>
        <Text style={styles.title}>
          {title}
        </Text>
        <Text style={styles.confirmationText}>
          {subtitle} {metaText}
        </Text>
      </View>
      {isLoading ?
        <ActivityIndicator
          size="small"
          color={Theme.PRIMARY}
          animating={isLoading}
          style={styles.loading}
        />
        :
        <BookingFlowFooter>
          <FormError error={error} />
          <View style={styles.buttonsContainer}>
            <Button
              title={leftButtonText}
              onPress={leftButtonPress}
              fontColor={Theme.WHITE}
              containerStyle={[styles.leftButton, leftButtonOverrideStyles]}
            />
            <Button
              title={rightButtonText}
              onPress={rightButtonPress}
              containerStyle={[styles.rightButton, rightButtonOverrideStyles]}
              buttonType={ButtonTypes.OUTLINE}
            />
          </View>
        </BookingFlowFooter>
      }
    </View>
  );

ConfirmAction.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  rightButtonText: PropTypes.string.isRequired,
  leftButtonText: PropTypes.string.isRequired,
  rightButtonPress: PropTypes.func.isRequired,
  leftButtonPress: PropTypes.func.isRequired,
  metaText: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  leftButtonOverrideStyles: PropTypes.object,
  rightButtonOverrideStyles: PropTypes.object,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  buttonsContainer: {
    flexDirection: 'row',
  },
  leftButton: {
    flex: 1,
    flexBasis: 0,
    marginRight: 5,
  },
  rightButton: {
    flex: 1,
    flexBasis: 0,
  },
  confirmationText: {
    textAlign: 'center',
    fontSize: moderateScale(13, 1),
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom700,
    ...Platform.select({
      web: {
        fontSize: 20,
      }
    })
  },
  icon: {
    resizeMode: 'contain',
    width: 50,
    height: 50,
    ...Platform.select({
      web: {
        width: 70,
        height: 70,
      }
    })
  },
  confirmationCenterContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {
        paddingVertical: '10%',
      }
    })
  },
  title: {
    textAlign: 'center',
    fontSize: moderateScale(20, 1),
    color: Theme.CHARCOAL,
    fontFamily:Theme.Custom800,
    paddingVertical: 10,
    ...Platform.select({
      web: {
        fontSize: 30,
      }
    })
  },
  loading: {
    height: Sizes.ButtonHeight,
    margin: 15,
  }
});

export default translate(['bookings'], { wait: true })(ConfirmAction);
